import { render, staticRenderFns } from "./StudentPersonalData.vue?vue&type=template&id=29fd9da8&scoped=true"
import script from "./StudentPersonalData.vue?vue&type=script&lang=js"
export * from "./StudentPersonalData.vue?vue&type=script&lang=js"
import style0 from "./StudentPersonalData.vue?vue&type=style&index=0&id=29fd9da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fd9da8",
  null
  
)

export default component.exports